/**
 * CSS variables that mirror the legacy `@atlaskit/page-layout` CSS custom properties.
 *
 * These are provided for consumers that previously relied on the `@atlaskit/page-layout`
 * CSS variables and need to reference them when using the navigation system.
 */

export const LEFT_PANEL_WIDTH = 'var(--leftPanelWidth, 0px)';
export const RIGHT_PANEL_WIDTH = 'var(--rightPanelWidth, 0px)';
export const LEFT_SIDEBAR_WIDTH = 'var(--leftSidebarWidth, 0px)';
export const RIGHT_SIDEBAR_WIDTH = 'var(--rightSidebarWidth, 0px)';
export const TOP_NAVIGATION_HEIGHT = 'var(--topNavigationHeight, 0px)';
export const BANNER_HEIGHT = 'var(--bannerHeight, 0px)';
